<template>
  <div class="addAccountingComputerizationNotice">
    <div class="newsDetial-header" v-if="!disabled">
      <div class="newsDetial-title">新建内容</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">请按照表单要求添加和修改数据</div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="标题"
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.replyTitleName"
              :disabled="disabled"
              @change="eightyfive('replyTitleName')"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">回复部门<span class="required">*</span></span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="disabled"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.replyDepartmentId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">回复人<span class="required">*</span> </span>
            <a-select
              disabled
              placeholder="请添加"
              class="w300"
              v-model="Form.replyPerson"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
        <div class="edui-default" v-show="!disabled">
          <template>
            <script id="editor" ref="ueditor" type="text/plain"></script>
            <blank height="15"> </blank>
          </template>
        </div>
        <div
          v-if="disabled"
          class="newsDetial-cont-view"
          v-html="Form.replyText"
        ></div>
      </div>
    </div>
    <div class="detial-cont">
      <!-- 附件 -->
      <accessories-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <template v-if="isLook != 1">
      <div class="ml20 bta">
        在{{ partyNoticeForm.sendTime }}，{{ partyNoticeForm.organizationName }}
        <span v-for="i in queryUserList" :key="i.id">
          <span v-if="i.id == partyNoticeForm.initatorId">{{
            i.fullName
          }}</span>
        </span>
        写道：
      </div>
      <div class="detial-cont">
        <div class="newsDetial-cont-view" v-html="partyNoticeForm.text"></div>
        <!-- 附件 -->
        <accessories-table
          v-model="partyNoticeForm.pnfiles"
          :file="partyNoticeForm.pnfiles"
          :disabled="true"
        ></accessories-table>
      </div>
    </template>
    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goback">
        返回
      </a-button>
      <!-- <a-button
        v-if="!disabled"
        :loading="loading && Form.draft == 1"
        type="primary"
        class="orange-btn"
        @click="preserveFn"
        :style="{ marginRight: '20px' }"
      >
        保存
      </a-button> -->
      <a-button
        v-if="!disabled"
        :loading="loading && Form.draft == 2"
        type="primary"
        :style="{ marginRight: '20px' }"
        @click="submitFn"
      >
        发送
      </a-button>
    </bottomSuspension>
  </div>
</template>

<script>
let vm = this
import {
  PartyNoticeDetial,
  updatepartyNoticeUser,
  partyNoticeUserDetial
} from './api/api'
import { mapState, mapActions } from 'vuex'
import AccessoriesTable from '@/components/accessories-table/index.vue'
export default {
  components: {
    AccessoriesTable
  },
  data() {
    return {
      loading: false,
      Form: {},
      id: '', //回复id
      dateFormat: 'YYYY-MM-DD',
      // 富文本
      editor: null,
      editorContent: '',
      isDisabledTrue: true,
      updateList: null,
      partyNoticeId: '', // 通知id
      partyNoticeForm: {}, //通知详情
      isLook: '' // 1只看回复
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList // 用户列表
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      this.proQueryParams = this.$route.query
      if (this.proQueryParams.isEdit) {
        if (
          this.proQueryParams.isEdit === '100' ||
          this.proQueryParams.isEdit === '1'
        ) {
          return true
        } else {
          return false
        }
      } else {
        // 草稿箱或退回状态  可编辑
        return false
      }
    }
  },
  created() {
    vm = this
    this.getorganizationUserList()
    this.getqueryUserList()
  },
  mounted() {
    this.isLook = this.$route.query.isLook ? this.$route.query.isLook : ''
    this.partyNoticeId = this.$route.query.partyNoticeId
    PartyNoticeDetial({ id: this.partyNoticeId }).then((res) => {
      if (res.data.code == 0) {
        this.partyNoticeForm = res.data.data
      }
    })
    this.id = this.$route.query.id
    if (this.$route.query.isEdit) {
      this.partyNoticeUserDetialGian()
    } else {
      this.Form.replyPerson = this.$store.state.app.userInfo.id
      this.$set(
        this.Form,
        'replyDepartmentId',
        this.$store.state.app.organizationId
      )
    }
    // 判断富文本是否可编辑
    if (!this.disabled) {
      // 可编辑
      this.isDisabledTrue = true
      this.wangeditorFn()
    } else {
      this.isDisabledTrue = false
      this.wangeditorFn()
    }
  },
  methods: {
    ...mapActions(['getorganizationUserList', 'getqueryUserList']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    partyNoticeUserDetialGian() {
      // 获取详情
      partyNoticeUserDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.updateList = this.Form.files
          this.Form.replyPerson = parseInt(this.Form.replyPerson)
          setTimeout(() => {
            this.editor.setContent(res.data.data.replyText)
          }, 600)
        }
      })
    },
    wangeditorFn() {
      // 初始化百度ueditor富文本
      UE.delEditor('editor')
      UE.getEditor('editor', {
        initialFrameWidth: '100%',
        initialFrameHeight: 450, // 设置默认高度
        scaleEnabled: true // 不自动拉伸高度
      })
      this.editor = UE.getEditor('editor', {
        // initialContent: '请输入内容', // 初始化编辑器的内容,也可以通过textarea/script给值
        BaseUrl: '',
        UEDITOR_HOME_URL: vm.$bdPackConfig.baiduEditorUrl,
        autoFloatEnabled: false
      })
      UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl
      UE.Editor.prototype.getActionUrl = function (action) {
        // let ts = this
        if (action === 'upload') {
          return vm.$bdPackConfig.baiduUploadUrl
        } else {
          return this._bkGetActionUrl.call(this, action)
        }
      }
      let ue = UE.getEditor('editor')
      if (!this.isDisabledTrue) {
        // 处理all-editor报错 无法禁用富文本问题
        document.getElementById('edui1_toolbarbox').style.display = 'none'
        ue.ready(function () {
          ue.setDisabled()
        })
      } else {
        ue.ready(function () {
          ue.setEnabled()
        })
      }
    },
    goback() {
      // this.$router.push("/AccountingComputerizationNoticeReceived");
      this.$router.go(-1)
    },
    preserveFn(type) {
      // this.Form.draft = 1;
      this.saveFormFn('保存')
    },

    submitFn() {
      // this.Form.draft = 2;
      this.saveFormFn('添加')
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85)
        this.$message.destroy()
        this.$message.warning('只能输入85个字')
      }
    },
    saveFormFn(type) {
      this.Form.files = this.updateList
      this.Form.replyText = this.editor.getContent()
      //获取部门名称
      let organizationName = ''
      this.organizationUserList.forEach((item, index) => {
        if (item.organizationId == this.Form.replyDepartmentId) {
          organizationName = item.organizationname
        }
      })
      this.Form.replyDepartmentName = organizationName
      if (!this.Form.replyDepartmentId) {
        this.$message.error('请添加部门')
        return false
      }
      if (!this.Form.replyText) {
        this.$message.error('请添加正文')
        return
      }
      this.Form.id = this.id
      this.loading = true
      if (this.id) {
        updatepartyNoticeUser(this.Form).then((res) => {
          this.loading = false
          if (res.data.code == 0) {
            this.$message.success('回复成功')
            this.$router.push('/AccountingComputerizationNoticeReceived')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bta {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: -18px;
}
.edui-default {
  width: 857px;
  margin: 20px auto;
}
.addAccountingComputerizationNotice {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      // height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.whiteSpace {
  white-space: nowrap;
}

.newsDetial-cont-view {
  // margin: 0 16px;
  background: #fff;
  padding: 30px;
  color: rgba(56, 56, 56, 1);
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/AccountingComputerizationNotice/reply.vue